import { pathBuilder } from 'config/paths/index';

export const root = '/admin/company';
export default pathBuilder(root);
